import React from 'react';
import PropTypes from 'prop-types';

const likeTypesPicker = (props) => {
  const listItems = props.likeTypes.map(likeType => {
    const handleClick = () => { props.onLikeTypePicked(likeType) };
    return <button key={likeType.id} onClick={handleClick}>{likeType.name}</button>;
  });

  return (
    <ul>
      {listItems}
    </ul>
  );
};

likeTypesPicker.propTypes = {
  likeTypes: PropTypes.array.isRequired,
  onLikeTypePicked: PropTypes.func.isRequired
};

export default likeTypesPicker;


// WEBPACK FOOTER //
// ./src/views/likeTypesPicker.js